// import { Chip, MenuItem, Select } from "@mui/material";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import CancelIcon from "@mui/icons-material/Cancel";

// const StatusCell = ({ params, setSelectedRow, setOpenStatusChangeModal }) => {
//   // console.log("parms test for hold reason",params)
//   return (
//     <Select
//       value={params.value}
//       renderValue={(value) => (
//         <Chip
//           icon={value === 1 ? <CheckCircleIcon /> : <CancelIcon />}
//           label={value === 1 ? "Active" : "Inactive"}
//           color={value === 1 ? "success" : "default"}
//           variant="outlined"
//         />
//       )}
//       label="Status"
//       onChange={() => {
//         setSelectedRow(params.row);
//         setOpenStatusChangeModal(true);
//       }}
//       sx={{
//         height: "100%",
//         minHeight: "52px",
//         border: "none",
//         "& .MuiOutlinedInput-notchedOutline": { border: "none" }, // Remove the outline
//         "&:hover .MuiOutlinedInput-notchedOutline": { border: "none" },
//         "&.Mui-focused .MuiOutlinedInput-notchedOutline": { border: "none" },
//       }}
//     >
//       <MenuItem value={1}>
//         <Chip label="Active" color="success" />
//       </MenuItem>
//       <MenuItem value="0">
//         <Chip label="Inactive" color="default" />
//       </MenuItem>
//     </Select>
//   );
// };

// export default StatusCell;

// ************************************************************************************************************************
import { Chip, MenuItem, Select } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";

const StatusCell = ({ params, setSelectedRow, setOpenStatusChangeModal }) => {
  // Check if status update is allowed
  const allowStatusUpdate = params.row.allow_status_update;
  
  // If status update is NOT allowed (allow_status_update !== 1), show static chip without dropdown
  if (allowStatusUpdate !== 1) {
    return (
      <Chip
        icon={params.value === 1 ? <CheckCircleIcon /> : <CancelIcon />}
        label={params.value === 1 ? "Active" : "Inactive"}
        color={params.value === 1 ? "success" : "default"}
        variant="outlined"
        sx={{
          height: "32px",
          cursor: "default",
          // No custom icon colors - using MUI defaults
        }}
      />
    );
  }

  // If status update IS allowed (allow_status_update === 1), show interactive dropdown
  return (
    <Select
      value={params.value}
      renderValue={(value) => (
        <Chip
          icon={value === 1 ? <CheckCircleIcon /> : <CancelIcon />}
          label={value === 1 ? "Active" : "Inactive"}
          color={value === 1 ? "success" : "default"}
          variant="outlined"
        />
      )}
      label="Status"
      onChange={() => {
        setSelectedRow(params.row);
        setOpenStatusChangeModal(true);
      }}
      sx={{
        height: "100%",
        minHeight: "52px",
        border: "none",
        "& .MuiOutlinedInput-notchedOutline": { border: "none" },
        "&:hover .MuiOutlinedInput-notchedOutline": { border: "none" },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": { border: "none" },
      }}
    >
      <MenuItem value={1}>
        <Chip label="Active" color="success" />
      </MenuItem>
      <MenuItem value={0}>
        <Chip label="Inactive" color="default" />
      </MenuItem>
    </Select>
  );
};

export default StatusCell;